import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label", "onKeydown"]
const _hoisted_2 = { "data-ref": "title" }

import { Tooltip } from 'bootstrap';

import {
  onMounted,
  ref,
} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
  trigger: {
    type: String,
    required: false,
    default: () => 'hover focus click',
  },
  ariaLabel: {
    type: String,
    required: false,
    default: () => 'Informationen anzeigen',
  },
},
  setup(__props) {

const props = __props;

const root = ref<InstanceType<typeof HTMLElement>>();
const tooltip = ref<Tooltip | null>(null);

const toggle = () => {
  if (tooltip.value) {
    tooltip.value.toggle();
  }
};

onMounted(() => {
  const title = root.value?.querySelector('[data-ref="title"]');

  if (root.value && title) {
    tooltip.value = new Tooltip(root.value, {
      html: true,
      title: title.innerHTML,
      trigger: props.trigger,
    });

    title.remove();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "io-tooltip",
    tabindex: "0",
    role: "button",
    "aria-label": __props.ariaLabel,
    onKeydown: [
      _withKeys(_withModifiers(toggle, ["prevent"]), ["enter"]),
      _withKeys(_withModifiers(toggle, ["prevent"]), ["space"])
    ]
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "title")
    ])
  ], 40, _hoisted_1))
}
}

})